import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { BulkImportPartnerSteper } from "./BulkImportSteper";
import BulkImportPartnerStep1 from "./BulkImportStep1";
import BulkImportPartnerStep2 from "./BulkImportStep2";
import BulkImportPartnerStep3 from "./BulkImportStep3";
import ResultModal from "../Common/ResultModal";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import SpinnerLoading from "../Common/SpinnerLoading";
import { partnerService } from "../../Services/partner.service";

import { roles } from "../../Config/Roles";

const BulkImportPartner = ({ match }) => {
  const { locName, locTenant, locStore, locPos } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { cashier, accountant, manager } = roles;
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const { t: translator } = useTranslation();
  const [step, setStep] = useState(1);
  const [data, setData] = useState();
  const [dataForImport, setDataForImport] = useState();
  const [generalError, setGeneralError] = useState();
  const [serverErrors, setServerErrors] = useState();
  const [localErrors, setLocalErrors] = useState();

  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  useEffect(() => {
    if ([cashier, manager, accountant].includes(Number(roleId)))
      history.push("/error-page/401");
    setIsLoading(true);
    if (data) {
      // provjeravamo da li ima zapisa, ako nema...
      if (data.data && data.data.length === 0) {
        setGeneralError("Datoteka nema zapisa za uvoz.");
        return;
      }

      // provjeravamo da li header odgovara očekivanom formatu
      let headerKeys = [];
      // headerKeys.push(translator("Id"));
      headerKeys.push(translator("Naziv"));
      headerKeys.push(translator("Oib"));
      headerKeys.push(translator("Napomena"));
      headerKeys.push(translator("Ulica"));
      headerKeys.push(translator("Kućni broj"));
      //headerKeys.push(translator("Dodatak kućnog broja"));
      headerKeys.push(translator("Grad"));
      headerKeys.push(translator("Poštanski broj"));
      headerKeys.push(translator("Država"));
      // headerKeys.push(translator("IBAN"));
      //headerKeys.push(translator("Telefon"));
      //headerKeys.push(translator("Email"));

      const dataHeaderKeys = Object.keys(data.data[0]);
      let missingKeys = [];
      headerKeys.forEach((k) => {
        if (!dataHeaderKeys.includes(k)) {
          missingKeys.push(k);
        }
      });

      if (missingKeys.length > 0) {
        setGeneralError(
          `${translator(
            "BulkImport-StepOne-Data-wrongData"
          )} ${missingKeys.join(", ")}`
        );
        return;
      }

      let localValidationErrors = [];

      const importData = data.data.map((d, i) => {
        let _errorList = [];

        if (_errorList.length > 0) {
          localValidationErrors.push({ index: i, errors: _errorList });
        }

        return {
          // id: d[translator("Id")],
          name: d[translator("Naziv")],
          taxNumber: d[translator("Oib")],
          //description: d[translator("Napomena")],
          //street: d[translator("Ulica")],
          //streetNumber: d[translator("Kućni broj")],
          //streetNumberExtension: d[translator("Dodatak kućnog broja")],
          //city: d[translator("Grad")],
          //postalNumber: d[translator("Poštanski broj")],
          country: d[translator("Država")],
          //iban: d[translator("IBAN")],
          //phone: d[translator("Telefon")],
          //email: d[translator("Email")],
        };
      });

      if (localValidationErrors.length > 0) {
        setLocalErrors(localValidationErrors);
        setIsLoading(false);
        setStep(step + 1);
        return;
      }

      // serverska validacija
      partnerService
        .bulkImportValidate({
          tenantId: Number(locTenant),
          data: importData,
        })
        .then((res) => {
          if (res.data.success) {
            console.log("ss",res.data.data);
            setDataForImport(res.data.data);
          } else {
            setServerErrors(res.data.errors);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
          setStep(step + 1);
        });
    }
  }, [data]);

  const handleImport = () => {
    partnerService
      .bulkImport({
        tenantId: Number(locTenant),
        data: dataForImport.data,
      })
      .then((res) => {
        res.data.success
          ? setResultModal({
            show: true,
            title: translator("Bulkimport-SuccessModal-Title"),
            text: translator("Bulkimport-SuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: true,
          })
          : setResultModal({
            show: true,
            title: translator("Bulkimport-UnsuccessModal-Title"),
            text: translator("Bulkimport-UnsuccessModal-Text"),
            btnClass: "btn btn-danger",
            success: false,
          });
      })
      .catch((err) => {
        setResultModal({
          show: true,
          title: translator("Bulkimport-UnsuccessModal-Title"),
          text: translator("Bulkimport-UnsuccessModal-Text"),
          btnClass: "btn btn-danger",
          success: false,
        });
      });
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    if (resultModal.success) goBack();
  };

  const goBack = () => {
    switch (locName) {
      case "stores":
        history.push(`/${locName}/${locStore}`);
        break;
      case "tenants":
        history.push(`/${locName}/${locTenant}`);
        break;
      default:
        history.push("/error");
    }
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setDataForImport([]);
    setStep(step - 1);
  };

  switch (step) {
    case 1:
      return (
        <BulkImportPartnerSteper
          step={step}
          subtitle={translator("Bulkimport-SteperSubtitle-MassImportOfItems")}
          progress="20"
        >
          <BulkImportPartnerStep1
            setData={setData}
            handleCancel={goBack}
            generalError={generalError}
          />
        </BulkImportPartnerSteper>
      );
    case 2:
      return (
        <BulkImportPartnerSteper
          step={step}
          subtitle={translator("Bulkimport-SteperSubtitle-DataVerification")}
          progress="40"
        >
          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}
          {!isLoading && (
            <BulkImportPartnerStep2
              data={data}
              serverErrorList={serverErrors}
              localErrorList={localErrors}
              setServerErrors={setServerErrors}
              prevStep={prevStep}
              nextStep={nextStep}
            />
          )}
        </BulkImportPartnerSteper>
      );
    case 3:
      return (
        <>
          <BulkImportPartnerSteper
            step={step}
            subtitle={translator("Bulkimport-SteperSubtitle-Save")}
            progress="60"
          >
            <BulkImportPartnerStep3
              prevStep={prevStep}
              handleImport={handleImport}
            />
          </BulkImportPartnerSteper>
          <ResultModal
            show={resultModal.show}
            title={resultModal.title}
            text={resultModal.text}
            btnClass={resultModal.btnClass}
            handleClose={handleCloseResultModal}
          />
        </>
      );
    default:
      return <></>;
  }
};

export default BulkImportPartner;
